import { useEffect, useState } from "react";
import { PiRoadHorizonDuotone } from "react-icons/pi";
import { FormField } from "src/components/formfield";

export function ManualMiles({
    formData,
    handleCancel,
    handleSubmit,
}: {
    formData: { origin: string; destination: string };
    handleCancel: () => void;
    handleSubmit: (miles: string) => void;
}) {
    const [manualMiles, setManualMiles] = useState<string>("");
    const [milesError, setMilesError] = useState<string>("");
    const [validForm, setValidForm] = useState<boolean>(false);

    const isPositiveNumber = (value: string) => {
        return !isNaN(+value) && parseFloat(value) >= 0;
    };

    useEffect(() => {
        var validMiles = isPositiveNumber(manualMiles);
        setMilesError(
            validMiles || manualMiles == ""
                ? ""
                : "value must be a positive number",
        );

        setValidForm(validMiles);
    }, [manualMiles]);

    return (
        <div className="flex flex-col items-center justify-center">
            <div className="bg-gray-100 p-5 rounded-full mb-4">
                <PiRoadHorizonDuotone className="w-16 h-16 text-[#ac2226]" />
            </div>
            <h2 className="text-xl font-bold text-gray-700 mb-2">
                Lane Not Found
            </h2>
            <p className="text-gray-600 max-w-md text-center">
                We don't recognize this lane, please confirm the origin and
                destination zip codes before entering loaded miles manually.
            </p>

            <form
                onSubmit={(event) => {
                    event.preventDefault();
                    handleSubmit(manualMiles);
                }}
                className="max-w-md w-full gap-2 flex flex-col"
            >
                <div className="flex flex-row gap-6 justify-center mt-4">
                    <fieldset>
                        <legend className="fieldset-legend text-xs font-medium text-gray-600">
                            Origin Zip
                        </legend>
                        <span className="text-2xl text-nowrap">
                            {formData.origin}
                        </span>
                    </fieldset>

                    <fieldset>
                        <legend className="fieldset-legend text-xs font-medium text-gray-600">
                            Destination Zip
                        </legend>
                        <span className="text-2xl text-nowrap">
                            {formData.destination}
                        </span>
                    </fieldset>

                    <FormField
                        legend="Loaded Miles"
                        className={
                            "input input-bordered input-sm w-full pl-3 pr-8" +
                            "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                        }
                        type="number"
                        maxLength={5}
                        max={99999}
                        value={manualMiles}
                        onChange={(e) => {
                            setManualMiles(e.target.value);
                        }}
                        required
                        error={milesError}
                    />
                </div>

                <div className="flex justify-center gap-4 mt-4">
                    <button
                        type="reset"
                        className="btn btn-sm btn-link "
                        onClick={(event) => {
                            event.preventDefault();
                            handleCancel();
                        }}
                    >
                        Cancel
                    </button>

                    <button
                        type="submit"
                        className="btn btn-sm btn-primary"
                        disabled={!validForm}
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    );
}
